import style from './style'
import { createUseStyles } from 'react-jss'
import {
  Button
} from 'UI'
import { MobileLearningPathPricingPath } from 'navigation/Routes'
import Text from './text.json'
const useStyle = createUseStyles(style)

export default ({ goToUrl }) => {
  const { container, buttonClass } = useStyle()

  return (
    <div className={container}>
      <Button
        height={54}
        className={buttonClass}
        onHandleClick={() => goToUrl(MobileLearningPathPricingPath)}
        label={Text.accessLearningPath}
      />
    </div>
  )
}
